import { useMemo } from "react";
import { createContext, useReducer } from "react";

export const ProjectContext = createContext();
export const ProjectDispatchContext = createContext();

const initialState = {
    activeProject: null,
    recentlyViewedDatasets: [],
}

const filtersReducer = (state, action) => {
    switch (action.type) {
        case 'SET_PROJECT':
            if (action.payload === state.activeProject) return state;
            // Update project and reset recently viewed datasets list
            return {...state, activeProject: action.payload, recentlyViewedDatasets: []};
        case 'ADD_RECENTLY_VIEWED_DATASETS':
            /*
            * On each new activeRun change, add that active dataset to the list of visible runs
            * (Recently Viewed Datasets). Shift the least recently viewed dataset off of the list.
            * 
            * A value of 1 is used as a sentinel value to render a blank space if fewer than 3 datasets
            * have been recently viewed.
            */
            const filtered = state.recentlyViewedDatasets.filter((dataset) => dataset.id !== action.payload.id)
            return {...state, recentlyViewedDatasets: [action.payload, ...filtered, 1, 1, 1].slice(0, 3)};
        case 'REMOVE_RECENTLY_VIEWED_DATASETS':
            // Remove the dataset from the recently viewed datasets list
            const filteredList = state.recentlyViewedDatasets.filter((dataset) => dataset.id !== action.payload.id);
            return {...state, recentlyViewedDatasets: [...filteredList, 1, 1, 1].slice(0, 3)};
        default:
            return state;
    }
}

export const ProjectProvider = ({ children }) => {
    const [state, dispatch] = useReducer(filtersReducer, initialState);

    const dispatchFuncs = useMemo(() => ({
        setActiveProject: (project) => dispatch({ type: 'SET_PROJECT', payload: project }),
        addRecentlyViewedDataset: (dataset) => dispatch({ type: 'ADD_RECENTLY_VIEWED_DATASETS', payload: dataset }),
        removeRecentlyViewedDataset: (dataset) => dispatch({ type: 'REMOVE_RECENTLY_VIEWED_DATASETS', payload: dataset }),
    }), [dispatch]);

    return (
        <ProjectContext.Provider value={state}>
            <ProjectDispatchContext.Provider value={dispatchFuncs}>
                {children}
            </ProjectDispatchContext.Provider>
        </ProjectContext.Provider>
    );
}